// @TODO <HEALTH2019>
App.controller('HealthInsuranceWithPaymentsSummaryCtrl', ['$scope', '$sce', '$state', '$http', '$mdDialog', 'Config', '$stateParams', 'insuranceService', 'statesService', '$filter', 'profileService', '$timeout', 'dataUser', 'Blob', 'FileSaver', '$rootScope', 'healthInsuranceService', function ($scope, $sce, $state, $http, $mdDialog, Config, $stateParams, insuranceService, statesService, $filter, profileService, $timeout, dataUser, Blob, FileSaver, $rootScope, healthInsuranceService) {
// @TODO </HEALTH2019>
    $scope.stateParams = $stateParams;

    $scope.page = 'healthInsuranceWithPayments';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Podsumowanie';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.healthInsuranceWithPayments.list';
    $scope.$emit('link', $scope.link);

    $scope.data = $scope.stateParams.declaration;
    if (!$scope.data) {
        $state.go('root.home.healthInsuranceWithPayments.list');
    }

    $scope.variantName = $scope.data.healthInsurance.name
    $scope.numberOfInsured = 1;
    if ($scope.data.partner) {
        $scope.numberOfInsured = $scope.numberOfInsured + 1;
    }
    if ($scope.data.child1) {
        $scope.numberOfInsured = $scope.numberOfInsured + 1;
    }
    if ($scope.data.child2) {
        $scope.numberOfInsured = $scope.numberOfInsured + 1;
    }
    if ($scope.data.child3) {
        $scope.numberOfInsured = $scope.numberOfInsured + 1;
    }
    if ($scope.data.child4) {
        $scope.numberOfInsured = $scope.numberOfInsured + 1;
    }
    if ($scope.data.child5) {
        $scope.numberOfInsured = $scope.numberOfInsured + 1;
    }
    $scope.price = $scope.data.healthInsurance.summaryPrice;
    $scope.bankAccountNumber = $scope.data.bankAccountNumber.accountNumber;
    $scope.proposedDate = $scope.data.proposedDate;
    $scope.type = $scope.data.healthInsurance.type;

    $scope.getDeclaration = function(ev, value) {
        var el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }
        var id = value.uuid, barcode = value.barcode || '';
        healthInsuranceService.getDeclaration(id).then(function (data) {
            if (data.status === 200) {
                var data = new Blob([data.data], {type: 'application/pdf'});
                FileSaver.saveAs(data, 'Deklaracja_' + barcode + '.pdf');
            }

            $timeout(function () {
                $(ev.currentTarget).removeClass('disabled');
            }, 1500);
        });
    }
}]);
